export default __webpack_public_path__ + "static/leaf8-min-e0c1182b9610c66d14d53aa2067697d8.svg";